/**
 * The external dependencies.
 */
import {createAction} from 'redux-actions';
/**
 * The internal dependencies.
 */
import {toString} from '../../common/utilities';

/**
 * Mark a network request as running.
 *
 * @type   {Function}
 * @param  {String|Function} action
 * @return {Object}
 */
export const startRequest = createAction('requests/start-request', action => ({
    id: toString(action)
}));

/**
 * Mark a network request as completed.
 *
 * @type   {Function}
 * @param  {String|Function} action
 * @return {Object}
 */
export const endRequest = createAction('requests/end-request', (action, successMessage = '') => ({
    id: toString(action),
    successMessage
}));

/**
 * Mark a network request as failed.
 *
 * @type   {Function}
 * @param  {String|Function} action
 * @param  {String|Object}   error
 * @return {Object}
 */
export const endRequestWithError = createAction('requests/end-request-with-error', (action, error = '') => ({
    id: toString(action),
    error: toString(error)
}));

/**
 * Reset requests
 *
 * @type   {Function}
 * @return {Object}
 */
export const resetRequests = createAction('requests/reset');



// WEBPACK FOOTER //
// ./src/store/requests/actions.js